<template>
  <div class="pa-2">
    <h4 class="mt-3 mb-2 header" style="font-size: 15px">
      {{ $t('setup_line_bot_profile') }}
    </h4>
    {{ $t('this_feature_is_working_only_with_line_bot_only') }}

    <div
      v-if="intent"
      class="z-border-red pa-2 mt-2"
      :style="{ cursor: type == 'edit' ? 'pointer' : 'default' }"
      @click="handleManageBotProfile()"
    >
      <template v-if="intent.bot_profile_id">
        <v-layout justify-center align-center>
          <v-flex class="pa-2" shrink>
            <v-avatar :key="intent.bot_profile_id" size="40">
              <img :src="intent.bot_profile_pic" />
            </v-avatar>
          </v-flex>
          <v-flex>
            {{ intent.bot_profile_name }}
          </v-flex>
          <v-flex v-if="type == 'edit'" shrink>
            <v-btn icon small outline @click.stop="handleSelectBotProfile(undefined)">
              <v-icon small>delete</v-icon>
            </v-btn>
            <v-btn icon small outline @click="showDialog = true">
              <v-icon small>edit</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
      <template v-else>
        <template v-if="type == 'edit'">
          <div style="text-align: center">
            <v-icon small class="mr-2">add</v-icon>
            {{ $t('select_bot_profile') }}
          </div>
        </template>
        <template v-else>
          <div style="text-align: center">
            {{ $t('no_selected_bot_profile') }}
          </div>
        </template>
      </template>
    </div>
    <dialog-bot-profile
      v-model="showDialog"
      @onSelectAvatar="handleSelectBotProfile"
    ></dialog-bot-profile>
  </div>
</template>

<script>
import DialogBotProfile from './DialogBotProfile.vue'
export default {
  // bot_profile_id
  // bot_profile_name
  // bot_profile_pic
  components: {
    DialogBotProfile
  },
  props: {
    intent: {
      default: undefined
    },
    type: {
      default: 'edit'
    }
  },
  data() {
    return {
      showDialog: false
    }
  },
  methods: {
    handleManageBotProfile() {
      if (this.type == 'edit') {
        this.showDialog = true
      }
    },
    handleSelectBotProfile(botProfile) {
      this.showDialog = false
      this.$emit(
        'onSelectBotProfile',
        botProfile
          ? {
              bot_profile_id: botProfile.id,
              bot_profile_name: botProfile.name,
              bot_profile_pic: botProfile.profile_pic
            }
          : undefined
      )
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/BotProfile/ManageBotProfile.vue